var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCountry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3497_8254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03589 3.34766H2.66089C2.32937 3.34766 2.01143 3.47935 1.77701 3.71377C1.54258 3.94819 1.41089 4.26614 1.41089 4.59766V13.3477C1.41089 13.6792 1.54258 13.9971 1.77701 14.2315C2.01143 14.466 2.32937 14.5977 2.66089 14.5977H11.4109C11.7424 14.5977 12.0604 14.466 12.2948 14.2315C12.5292 13.9971 12.6609 13.6792 12.6609 13.3477V8.97266",
    stroke: "#2173BB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7236 2.40981C11.9723 2.16117 12.3095 2.02148 12.6611 2.02148C13.0128 2.02148 13.35 2.16117 13.5986 2.40981C13.8473 2.65845 13.987 2.99568 13.987 3.34731C13.987 3.69894 13.8473 4.03617 13.5986 4.28481L7.66113 10.2223L5.16113 10.8473L5.78613 8.34731L11.7236 2.40981Z",
    stroke: "#2173BB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3497_8254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.161133 0.848633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCountry);
export default __webpack_public_path__ + "static/media/edit-country.4392f6823d387154d2adc42849953f73.svg";
export { ForwardRef as ReactComponent };